var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { Container, ContainerDisplays, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexJustifyContents, ContainerFlexWraps, ContainerPaddings, ContainerWidths } from '../../../templates/container';
import { getColumnWidth, ThemeUtils } from '../../../../utils';
import { ProductChips } from '../common/product-chips';
import { RatingAndReviewsTypes, RatingAndReviews } from '../common/rating-and-reviews';
import { ColorSelector } from '../common/color-selector';
import { ProductHeader } from './product-header';
import { PriceInfo } from '../common/price-info';
import { StockInfo } from '../common/stock-info';
import { ProductInfo } from '../common/product-info';
import { FlavourProfiles } from '../common/flavour-profiles';
import { AttributeSelector } from '../common/attribute-selector';
import { DeliveryInfo } from './delivery-info';
import { StickyCallToAction } from './sticky-call-to-action';
import { BackToShop } from './back-to-shop';
import { ProductImageGallery } from '../common/product-image-gallery';
import { ServiceHighlights } from './service-highlights';
var CAB = function (_a) {
    var _b, _c;
    var props = __rest(_a, []);
    var productChips = props.productChips, productHeader = props.productHeader, stockInfo = props.stockInfo, priceInfo = props.priceInfo, rating = props.rating, colorSelector = props.colorSelector, flavourProfiles = props.flavourProfiles, productInfo = props.productInfo, attributeSelectors = props.attributeSelectors, addToCart = props.addToCart, addToCartAlternativeContent = props.addToCartAlternativeContent, stickyCTA = props.stickyCTA, productImageGallery = props.productImageGallery, deliveryInfo = props.deliveryInfo, backToShop = props.backToShop, highlightsContent = props.highlightsContent, serviceHighlights = props.serviceHighlights, background = props.background;
    var COLOR_SELECTOR_CONTAINER_ID = 'color-selector-container';
    var addToCartRef = useRef(null);
    var addToCartContainer = {
        innerRef: addToCartRef
    };
    var innerContainerConfig = {
        width: ContainerWidths.Boxed,
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column
    };
    var containerConfig = {
        background: background,
        padding: ThemeUtils.getResponsiveProp([
            null,
            null,
            { x: ContainerPaddings.Size_5, y: ContainerPaddings.Size_5 },
            { x: ContainerPaddings.Size_6, y: ContainerPaddings.Size_5 },
            { x: ContainerPaddings.Size_7, y: ContainerPaddings.Size_5 }
        ])
    };
    var wrapperConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column,
        flexGap: ContainerFlexGaps.Size_4,
        padding: ThemeUtils.getResponsiveProp([
            { x: ContainerPaddings.Size_4, y: ContainerPaddings.Size_4 },
            { x: ContainerPaddings.Size_4, y: ContainerPaddings.Size_4 },
            { x: ContainerPaddings.Size_5, y: 0 },
            { x: ContainerPaddings.Size_6, y: 0 },
            { x: ContainerPaddings.Size_7, y: 0 }
        ]),
        width: ThemeUtils.getResponsiveProp([
            ContainerWidths.Full,
            ContainerWidths.Full,
            getColumnWidth(1, 2)
        ])
    };
    var mobileWrapperConfig = __assign(__assign({}, wrapperConfig), { display: ThemeUtils.getResponsiveProp([
            ContainerDisplays.Flex,
            ContainerDisplays.Flex,
            ContainerDisplays.None
        ]) });
    var desktopContainerConfig = {
        display: ThemeUtils.getResponsiveProp([
            ContainerDisplays.None,
            ContainerDisplays.None,
            ContainerDisplays.Flex
        ]),
        flexDirection: ContainerFlexDirections.Column,
        flexGap: ContainerFlexGaps.Size_4
    };
    var mainWrapperConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ThemeUtils.getResponsiveProp([
            ContainerFlexDirections.Column,
            ContainerFlexDirections.Column,
            ContainerFlexDirections.Row
        ])
    };
    var imageGalleryWrapperConfig = {
        width: ThemeUtils.getResponsiveProp([
            ContainerWidths.Full,
            ContainerWidths.Full,
            getColumnWidth(1, 2)
        ]),
        padding: ThemeUtils.getResponsiveProp([
            { x: ContainerPaddings.Size_0 },
            { x: ContainerPaddings.Size_4 },
            { x: 0 }
        ])
    };
    var atributeSelectorWrapper = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column,
        flexGap: ContainerFlexGaps.Size_4
    };
    var mobilePricePriceContainerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexJustifyContent: ContainerFlexJustifyContents.SpaceBetween,
        flexWrap: ContainerFlexWraps.Wrap,
        flexGap: ContainerFlexGaps.Size_3
    };
    var productChipsComponent = productChips && ((_b = productChips === null || productChips === void 0 ? void 0 : productChips.chipPropsList) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(ProductChips, { chipPropsList: productChips === null || productChips === void 0 ? void 0 : productChips.chipPropsList })) : null;
    var productHeaderComponent = productHeader && Object.keys(productHeader).length > 0 ? (React.createElement(ProductHeader, __assign({}, productHeader))) : null;
    var priceInfoComponent = priceInfo && Object.keys(priceInfo).length > 0 ? (React.createElement(PriceInfo, __assign({}, priceInfo))) : null;
    var ratingComponent = rating && (rating === null || rating === void 0 ? void 0 : rating.productId) ? (React.createElement(RatingAndReviews, __assign({ type: RatingAndReviewsTypes.InlineRating }, rating))) : null;
    var colorSelectorConfig = __assign(__assign({}, colorSelector), { id: COLOR_SELECTOR_CONTAINER_ID });
    var colorSelectorComponent = (colorSelector === null || colorSelector === void 0 ? void 0 : colorSelector.colorVariants) && colorSelector.colorVariants.length > 0 ? (React.createElement(ColorSelector, __assign({}, colorSelectorConfig))) : null;
    var stockInfoComponent = (stockInfo === null || stockInfo === void 0 ? void 0 : stockInfo.showStockMessage) ? (React.createElement(StockInfo, __assign({}, stockInfo))) : null;
    var intensityGaugeComponent = flavourProfiles && ((_c = flavourProfiles === null || flavourProfiles === void 0 ? void 0 : flavourProfiles.profiles) === null || _c === void 0 ? void 0 : _c.length) === 1 ? (React.createElement(FlavourProfiles, __assign({}, flavourProfiles))) : null;
    var attributeSelectorsComponent = attributeSelectors && attributeSelectors.length > 0 ? (React.createElement(Container, __assign({}, atributeSelectorWrapper), attributeSelectors.map(function (selector, index) {
        var _a, _b;
        if (((_a = selector === null || selector === void 0 ? void 0 : selector.attributeVariants) === null || _a === void 0 ? void 0 : _a.length) &&
            ((_b = selector === null || selector === void 0 ? void 0 : selector.attributeVariants) === null || _b === void 0 ? void 0 : _b.length) <= 1) {
            return null;
        }
        return (React.createElement(React.Fragment, { key: "attribute-selector-".concat(index) },
            React.createElement(AttributeSelector, __assign({}, selector))));
    }))) : null;
    var productInfoComponent = productInfo && Object.keys(productInfo).length > 0 ? (React.createElement(ProductInfo, __assign({}, productInfo))) : null;
    var addToCartComponent = addToCart ? (React.createElement(Container, __assign({}, addToCartContainer), addToCart)) : null;
    var stickyCTAConfig = __assign(__assign({}, stickyCTA), { addToCartRef: addToCartRef, colorSelectorAnchor: COLOR_SELECTOR_CONTAINER_ID });
    var deliveryInfoComponent = deliveryInfo && Object.keys(deliveryInfo).length > 0 ? (React.createElement(DeliveryInfo, __assign({}, deliveryInfo))) : null;
    var stickyCTAComponent = stickyCTA && Object.keys(stickyCTA).length > 0 ? (React.createElement(StickyCallToAction, __assign({}, stickyCTAConfig))) : null;
    var productImageGalleryData = __assign(__assign({}, productImageGallery), { background: background });
    var productImageGalleryComponent = productImageGallery && Object.keys(productImageGallery).length > 0 ? (React.createElement(ProductImageGallery, __assign({}, productImageGalleryData))) : null;
    var backToShopComponent = backToShop && Object.keys(backToShop).length > 0 ? (React.createElement(BackToShop, __assign({}, backToShop))) : null;
    var backToShopDesktopConfig = {
        display: ThemeUtils.getResponsiveProp([
            ContainerDisplays.None,
            ContainerDisplays.None,
            ContainerDisplays.Flex
        ]),
        padding: ThemeUtils.getResponsiveProp([
            null,
            null,
            { b: ContainerPaddings.Size_4 }
        ])
    };
    var serviceHighlightsComponent = serviceHighlights && Object.keys(serviceHighlights).length > 0 ? (React.createElement(ServiceHighlights, __assign({}, serviceHighlights))) : null;
    return (React.createElement(Container, __assign({}, containerConfig),
        React.createElement(Container, __assign({}, innerContainerConfig),
            React.createElement(Container, __assign({}, mobileWrapperConfig),
                backToShopComponent,
                productChipsComponent,
                productHeaderComponent,
                React.createElement(Container, __assign({}, mobilePricePriceContainerConfig),
                    priceInfoComponent,
                    ratingComponent)),
            backToShopComponent && (React.createElement(Container, __assign({}, backToShopDesktopConfig), backToShopComponent)),
            React.createElement(Container, __assign({}, mainWrapperConfig),
                React.createElement(Container, __assign({}, imageGalleryWrapperConfig), productImageGalleryComponent),
                React.createElement(Container, __assign({}, wrapperConfig),
                    React.createElement(Container, __assign({}, desktopContainerConfig),
                        productChipsComponent,
                        productHeaderComponent,
                        ratingComponent),
                    colorSelectorComponent,
                    stockInfoComponent,
                    React.createElement(Container, __assign({}, desktopContainerConfig), priceInfoComponent),
                    intensityGaugeComponent,
                    attributeSelectorsComponent,
                    addToCartComponent,
                    addToCartAlternativeContent,
                    deliveryInfoComponent,
                    productInfoComponent,
                    serviceHighlightsComponent,
                    highlightsContent)),
            stickyCTAComponent)));
};
export { CAB as ConfigureAndBuy };
